module.exports = __webpack_public_path__ + "img/1_no_poverty.b7b8dccb.svg";